import React from 'react';

export const SCALE_CONFIG = { cancel: false };

export const useCancelScale = () => {
  const setScale = (scale: number) => {
    document
      .querySelector('meta[name="viewport"]')
      ?.setAttribute(
        'content',
        `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no, minimum-scale=${scale}, viewport-fit=cover`
      );
  };
  SCALE_CONFIG.cancel = true;
  React.useLayoutEffect(() => {
    // 修复IOS下，页面缩放后，页面宽度不正确的问题
    setScale(1);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).RECLC_WINDOW_SIZE();
    return () => {
      SCALE_CONFIG.cancel = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).SCALE_WINDOW();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).RECLC_WINDOW_SIZE();
    };
  }, []);
};
